import { css } from '@emotion/react'

const styles = () => {
    return {
        icon: css`
            width: 24px;
            height: 24px;
            padding-right: 10px;
        `,
        validMessageContainer: css`
            padding: 0 20px;
        `,
        messageContainer: css`
            display: flex;
            padding: 10px 10px;
        `,
        notValidBackground: css`
            background-color: #FFE5E5;
        `,
        validBackground: css`
            background-color: #EAF9EF;
        `,
        messageText: css`
            font-size: 16px;
            line-height: 20px;
            padding-top: 2px;
        `,
        validMessageText: css`
            color: #17921F;
        `,
        notValidMessageText: css`
            color: #B92C2C;
        `,
    }
}

export default styles
